import { PRODUCT_ARTICLE_IMAGE_WIDTH } from "./BookListingItem";
import { ContributorItem } from "../types";
import { getPageLink } from "@/navigation/selectors";
import classNames from "classnames";
import NextLink from "next/link";
import Image from "next/image";
import { Link, Typography } from "@cappelendamm/design-system/react";
import { ListingItemProps } from "./types";
import Contributor from "@/utils/contributor.svg";

export function ContributorListingItem({
  item,
  config,
}: ListingItemProps<ContributorItem>) {
  const { objectID: sku, imageUrl, name, slug, description } = item;
  const href = getPageLink({ pageType: "contributor", params: slug });
  return (
    <article
      className={classNames(
        "group row-span-[var(--list-row-count)] grid grid-rows-subgrid gap-1",
        "outline-[var(--cvr-canvas-background)] active:rounded active:outline-3 active:outline-offset-4",
      )}
    >
      <NextLink
        href={href}
        aria-labelledby={`item-${sku}`}
        className={classNames(
          "relative row-span-full grid grid-rows-subgrid no-underline",
        )}
      >
        <div className="row-[1/-2] grid items-start gap-4">
          {imageUrl ? (
            <Image
              src={imageUrl}
              alt={`Portrettbilde av ${name}`}
              width={PRODUCT_ARTICLE_IMAGE_WIDTH}
              height={PRODUCT_ARTICLE_IMAGE_WIDTH}
              className="aspect-square h-fit w-fit rounded-[--spacing(2.5)] object-contain transition-transform sm:group-hover:scale-102"
              quality={85}
            />
          ) : (
            <Contributor className="aspect-square min-h-[140px] min-w-[140px] text-gray-200 transition-transform sm:group-hover:scale-102 sm:group-hover:text-gray-400" />
          )}
          <Typography
            id={`item-${sku}`}
            as="h3"
            variant="title-md"
            className={classNames("truncate", {
              "sm:group-hover:underline": href,
            })}
          >
            {name}
          </Typography>
          <Typography as="p" className="order-4 row-span-3 line-clamp-5">
            {description}
          </Typography>
        </div>
        <Link
          as="span"
          variant="inline"
          className="order-6 text-sm sm:group-hover:underline"
        >
          Les mer
        </Link>
      </NextLink>
    </article>
  );
}
